import DetailsEditor from "./DetailsEditor"
export default DetailsEditor
